import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
// material-ui icons
import Snackbar from "components/Snackbar/Snackbar.jsx";
import ModalPregunta from "components/Generales/ModalPregunta";
import AgregarModelo from "views/Modulos/Administracion/Modelos/AgregarModelo.jsx";
import Globales from "utils/Globales";
import { Edit, Close, AddCircle, Search, Clear, Filter9Plus } from "@material-ui/icons";
import ReactLoading from "react-loading";

class Modelo3D extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: '',
      NombreModelo: '',
      idCategoria: '',
      Textura: '',
      Titulo: '',
      modelos3D: [],
      categoriasModelos3D: [],
      mensaje: '',
      br: false,
      colorNotificacion: 'success',
      errorNombreModelo: false,
      modelos3DMostrar: [],
      entroFiltrar: false,
      notificacion: false
    };
    //Variable global para indicar el total de registros que se obtendra de la base de datos
    global.Fin = 5;
    global.entrar = true;
    global.response = null;
    this.eventoModalEliminar = this.eventoModalEliminar.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.eliminarModelo3D = this.eliminarModelo3D.bind(this);
    this.filtrarModelo3D = this.filtrarModelo3D.bind(this);
    this.seleccionado = {};
  }

  componentDidMount() {
    this.obtenerModelos3DFin();
    this.obtenerAllModelos3D();
  }

  //Obtener todos los registros guardados
  obtenerAllModelos3D() {
    fetch(Globales.Url + 'Modelos/Modelos', {
      method: 'GET',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) { //Error al obtener los registros
          this.setState({ modelos3D: [] });
        } else { //Obtuvo los registros correctamente
          this.setState({ modelos3D: data.data });
        }
      });

    //Obteniendo Categoria de modelos
    fetch(Globales.Url + 'Modelos/Categoria/', {
      method: 'GET',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) { //Error al obtener los registros
          this.setState({ categoriasModelos3D: [] });
        } else { //Obtuvo los registros correctamente
          this.setState({ categoriasModelos3D: data.data });
        }
      });
  }

  //Obtener el total de registros que se indican
  obtenerModelos3DFin() {
    fetch(Globales.Url + 'Modelos/Modelos/ListadoModelos', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ Fin: global.Fin })
    }
    ).then(res => {
      global.response = res.status;
      res.json()
        .then(data => {
          if (data.error) { //Error al obtener los registros
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
            this.showNotification();
          } else { //Obtuvo los registros correctamente
            this.setState({ modelos3DMostrar: data.data });
          }
        })
        .catch(err => console.error(err));
    });
  }

  //Función de editar registro
  editarModelo3D(id, Nombre, idCategoria) {
    this.setState({ _id: id, NombreModelo: Nombre, idCategoria: idCategoria, op: 1, showAgregar: true, Titulo: "Editar Modelo 3D" });
  }

  //Función de eliminar registro
  eliminarModelo3D(id) {
    fetch(Globales.Url + 'Modelos/Modelos/BajaModelo', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ _id: id })
    }
    ).then(res => res.json())
      .then(data => {
        if (data.error) {//Error al obtener los registros
          this.setState({ colorNotificacion: 'danger' });
        } else {//Obtuvo los registros correctamente
          this.setState({ colorNotificacion: 'success' });
        }
        this.setState({ mensaje: data.mensaje, show: false });
        this.showNotification("tr");
        this.obtenerModelos3DFin();
        this.limpiar();
      });
  }

  //Función para el evento de eliminar
  deleteEvent = (values) => {
    this.seleccionado = values;
    this.setState({ show: true });
  }

  //Función para habilitar el modal de eliminar
  eventoModalEliminar(e) {
    if (!e) {
      this.setState({ show: false });
      return;
    }
    //Eliminar el elemento
    this.eliminarModelo3D(this.seleccionado);
  }

  //Función para abrir el modal de agregar registro
  openModalAgregarModelo3D = () => {
    this.setState({ showAgregar: true, Titulo: "Nuevo Modelo 3D", op: 0 });
  }

  //Función que recupera valores para el modal de agregar
  eventoModalModelo3D = (mensaje, colorNotificacion) => {
    //Cambiar valores por default
    this.setState({ showAgregar: false, Titulo: "Nuevo Modelo 3D", NombreModelo: "", op: 0 })
    this.limpiar();
    //Validar que el mensaje venga diferente de vacio
    if (mensaje !== 'esc') {
      this.setState({ mensaje: mensaje, colorNotificacion: colorNotificacion })
      this.showNotification();
    }
  }

  //Función que habilita la notificación
  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false, notificacion: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  //Función para obtener el texto de los inputs
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  //Función para realizar el filtrado de búsqueda
  filtrarModelo3D() {
    var valor1 = 0;
    //Validar que el input no este vacio
    if (this.state.NombreModelo.trim() == '') {
      this.setState({ errorNombreEstado: true, colorNotificacion: 'danger', mensaje: "Complete el campo de búsqueda", NombreModelo: '' });
      valor1 = 1;
    } else {
      this.setState({ errorNombreEstado: false });
      valor1 = 0;
    }
    //Validar si hay campos requeridos
    if (valor1 > 0) { //Hay campos requeridos
      this.showNotification();
    } else { //No hay campos requeridos
      fetch(Globales.Url + 'Modelos/Modelos/FiltrarModelo', {
        method: 'POST',
        headers: {
          Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
        }
        , body: JSON.stringify(this.state)
      }
      ).then(res => res.json())
        .then(data => {

          if (data.error) { //Error en la respuesta
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
            this.showNotification();
          } else if (data.mensaje.length == 0) { //Ninguna coincidencia
            this.setState({ colorNotificacion: "warning",modelos3DMostrar:[], mensaje: "No hay ninguna coincidencia", entroFiltrar: true })
            this.showNotification();
          } else { //Filtrado exitoso
            this.setState({ colorNotificacion: 'success', modelos3DMostrar: data.mensaje, entroFiltrar: true })
          }
        })
        .catch(err => console.error(err));
    }
  }

  //Función para volver los valores por default
  limpiar() {
    this.setState({ NombreModelo: '', entroFiltrar: false });
    global.Fin = 5;
    global.entrar = true;
    global.response = null;
    this.obtenerModelos3DFin();
    this.obtenerAllModelos3D();
  }

  //Función para mostrar mas registros en la tabla
  verMas() {
    //Validar si entro a filtrar
    if (this.state.entroFiltrar) {
      this.limpiar();
    } else {
      //Creando variable con mas valor que la variable global
      var num = global.Fin + 5;
      //Validación de el valor de la variable global sea menor o igual que el total de registros obtenidos
      if (num <= this.state.modelos3D.length && global.entrar) {
        //Cambiando el valor de la variable global
        global.Fin = num;
        //Obteniendo el número de registros requeridos
        this.obtenerModelos3DFin();
      };
      //Validación de que el número total de registros requiridos sea mayor al total de registros y cambio de valor de variables
      if (num > this.state.modelos3D.length && global.entrar) {
        //Cambiando el valor de la variable para que no vuelva a traer mas registros
        global.entrar = false;
        //Cambiando el valor de la variable global
        global.Fin = this.state.modelos3D.length;
        //Obteniendo el total de los registros requeridos
        this.obtenerModelos3DFin();
      };
      //Validación de que ya no hay mas registros que mostrar
      if (!global.entrar) {
        this.setState({ mensaje: 'No hay más modelos 3D para mostrar', colorNotificacion: 'warning' });
        this.showNotification();
      };
    }
  }

  obtenerNombreCategoria(idCategoria) {
    var nombre = ''
    this.state.categoriasModelos3D.map(cat => {
      if (cat._id === idCategoria) {
        nombre = cat.NombreCategoriaModelo
      }
    });
    return nombre;
  }

  render() {
    let agregar;
    if (this.state.showAgregar == true) {
      agregar =
        <AgregarModelo
          Titulo={this.state.Titulo}
          NombreModelo={this.state.NombreModelo}
          idCategoria={this.state.idCategoria}
          TresD={this.state.TresD}
          Textura={this.state.Textura}
          categoriasModelos3D={this.state.categoriasModelos3D}
          _id={this.state._id}
          showAgregar={this.state.showAgregar}
          eventClick={this.eventoModalModelo3D}
          op={this.state.op}
        />
    }
    const { classes } = this.props;
    return (
      <div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info" text>
                <h4 className={classes.cardTitle}>Modelos 3D</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Búsqueda de Modelo 3D"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        onChange: this.handleChange,
                        value: this.state.NombreModelo,
                        name: "NombreModelo",
                        id: "NombreModelo",
                        type: "text",
                        error: this.state.errorNombreModelo
                      }}
                      className="mt-5"
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Button size="sm" type="submit" color="info" round className="pull-left mt-5" onClick={() => this.filtrarModelo3D()}><Search />Buscar</Button>
                    <Button size="sm" type="submit" color="danger" round className="pull-left mt-5" onClick={() => this.limpiar()}><Clear />limpiar</Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="info" round onClick={() => this.verMas()}><Filter9Plus />Ver Más</Button>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="success" round onClick={() => this.openModalAgregarModelo3D()}><AddCircle />Agregar</Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer justify="center">
          {/* Tabla de modelos */}
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info">
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <h4 className="pull-left">Lista de Modelos 3D</h4>
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                {global.response === 200 ?
                  <div className="table-wrapper-scroll-y">
                    <table className="col-xs-12 col-sm-12 col-md-12">
                      <thead>
                        <th className="center">Modelo 3D</th>
                        <th className="center">Categoría de Modelo 3D</th>
                        <th className="pull-right">Acciones</th>
                      </thead>
                      <tbody>
                        {this.state.modelos3DMostrar.map(Modelos => {
                          return (
                            <tr key={Modelos._id}>
                              <td>{Modelos.NombreModelo}</td>
                              <td>{this.obtenerNombreCategoria(Modelos.idCategoria)}</td>
                              <td className="pull-right">
                                <Button color="warning" round justIcon size="sm" onClick={() => this.editarModelo3D(Modelos._id, Modelos.NombreModelo, Modelos.idCategoria, Modelos.RutaModelo)}><Edit /></Button>
                                <Button color="danger" round justIcon size="sm" onClick={() => this.deleteEvent(Modelos._id)}><Close /></Button>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div> :
                  <GridContainer justify='center'>
                    <ReactLoading type={'bubbles'} color={'#CFCFCF'} height={'10%'} width={'10%'} />
                  </GridContainer>
                }

              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <div id="">
          <ModalPregunta
            Titulo={"Eliminar Modelo 3D"}
            Cuerpo={"¿Está seguro que desea eliminar el modelo 3D?"}
            show={this.state.show}
            eventClick={this.eventoModalEliminar}
          />
          {agregar}
        </div>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    )
  }
}

export default withStyles(headerLinksStyle)(Modelo3D);